import GameSignals from '@/signals/GameSignals'
import { BaseChildState } from '@stateMachine/BaseChildState'
import gsap from 'gsap'

export class FreeSpinsRetriggerState extends BaseChildState {
    private _fallbackTimeoutId: number = null
    private _isCompleted: boolean = false

    public canTrigger(): boolean {
        const isIntro: boolean = this._model.spinData.freebet && this._model.spinData.freebet.amount_left === this._model.spinData.freebet.total_amount_given

        return !this._model.isPromoSpinsRound() && this._model.spinData.bonus && (this._model.spinData.bonus.freebet_given > 0 && !isIntro)
    }

    public begin() {
        GameSignals.showFreeSpinsRetriggerComplete.connect(this.onRetriggerComplete)

        this._isCompleted = false
        GameSignals.showFreeSpinsRetrigger.emit(this._model.spinData.bonus.freebet_given)
        this._fallbackTimeoutId = window.setTimeout(this.onRetriggerComplete, 700)
    }

    private onRetriggerComplete = () => {
        if (this._isCompleted) {
            return
        }

        this._isCompleted = true
        if (this._fallbackTimeoutId !== null) {
            clearTimeout(this._fallbackTimeoutId)
            this._fallbackTimeoutId = null
        }

        gsap.to(this, {
            duration: 1,
            onComplete: () => {
                this.end()
            }
        })
    }

    public cleanUp() {
        if (this._fallbackTimeoutId !== null) {
            clearTimeout(this._fallbackTimeoutId)
            this._fallbackTimeoutId = null
        }

        GameSignals.showFreeSpinsRetriggerComplete.disconnect(this.onRetriggerComplete)
    }
}
